export default __webpack_public_path__ + "bee6cabe5446a6317abe405b3377a6cf.png";